import { getRequest } from "../http/HttpRequest";
import { OrganizationType } from "./types";

const getOrganizationByQuery = async (urlParam: string) => {
  try {
    // query to get organization
    const response = await getRequest("organizations?name=" + urlParam);

    //   get organization
    const organization: OrganizationType =
      !!response.data && response.data.organization;

    return organization;
  } catch (e) {
    return undefined;
  }
};

export { getOrganizationByQuery };
